import { useArtistRepository } from "@/pages/artists/hooks/use-artist-repository";
import { useEventRepository } from "@/pages/events/hooks/use-event-repository";
import { useGenreRepository } from "@/pages/genres/hooks/use-genre-repository";
import { useVenueRepository } from "@/pages/venues/hooks/use-venue-repository";

import { SandboxEntity } from "../types/entities";
import type { UseEntitySelectorProps } from "../types/entitySelector";

const useEntitySelector = (props: UseEntitySelectorProps) => {
  const { entityType } = props;
  const { search: searchArtists } = useArtistRepository();
  const { search: searchVenues } = useVenueRepository();
  const { search: searchGenres } = useGenreRepository();
  const { search: searchEvents } = useEventRepository();

  const handleSearch = async (
    query: string,
    onStatusChanged: (status: "loading" | "success" | "error") => void,
  ) => {
    if (!query) {
      return [];
    }
    onStatusChanged("loading");
    let entities: SandboxEntity[] = [];
    if (entityType === "artist") {
      entities = await searchArtists(query);
    } else if (entityType === "venue") {
      entities = await searchVenues(query);
    } else if (entityType === "genre") {
      entities = await searchGenres(query);
    } else if (entityType === "event") {
      entities = await searchEvents(query);
    }
    onStatusChanged("success");
    return entities;
  };

  const accessor = (option: SandboxEntity) => {
    return {
      ...option,
      id: option.id ?? "",
      name: option.name ?? "",
    };
  };

  return {
    handleSearch,
    accessor,
  };
};

export default useEntitySelector;
